var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"synonym-study"},[_c('h4',{staticClass:"title"},[_vm._v("Synonym Study")]),_vm._v(" "),_c('ul',_vm._l((_vm.getSynonymStudies),function(synonymStudies,synStudiesSlug){return _c('li',{key:'i' + synStudiesSlug,domProps:{"innerHTML":_vm._s(_vm.synonymStudyLink(synonymStudies))}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ab32c0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Synonym/SynonymStudy/SynonymStudy.vue
// module id = null
// module chunks = 